import axios from '../../plugins/axios'

export const getSettlementGoogleSheetsConfig = (_, { params = {} } = {}) => {
  return axios.get('/settings/settlement-google-sheets', { params })
}

export const updateSettlementGoogleSheetsConfig = (_, { data }) => {
  return axios.put('/settings/settlement-google-sheets', data)
}

export const testSettlementGoogleSheetsConnection = (_, { data } = {}) => {
  return axios.post('/settings/settlement-google-sheets/test', data)
}

export const syncSettlementGoogleSheets = (_, { data } = {}) => {
  return axios.post('/settings/settlement-google-sheets/sync', data)
}
